import { useState } from 'react';
import { C, FONT_UI } from '../../constants/design-tokens';

/**
 * TabBtn - centered icon + label below
 * Used in: right sidebar (General, Text, Media...) and format selector (Post, Story...)
 */
export const TabBtn = ({
  onClick,
  label,
  icon,
  active = false,
  panelId,
  disabled = false
}: {
  onClick: () => void;
  label: string;
  icon: React.ReactNode;
  active?: boolean;
  panelId?: string;
  disabled?: boolean;
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const variantStyles = getStyles(active, isHovered, disabled);

  return (
    <button
      data-panel-id={panelId}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '4px',
        padding: '10px 8px',
        borderRadius: '10px',
        cursor: disabled ? 'not-allowed' : 'pointer',
        minWidth: '56px',
        maxWidth: '56px',
        transition: 'background 0.15s, color 0.15s, opacity 0.15s',
        ...variantStyles.btn
      }}
    >
      <span style={{ display: 'flex', fontSize: '20px' }}>{icon}</span>
      <span
        style={{
          fontSize: '11px',
          fontFamily: FONT_UI,
          lineHeight: 1.2,
          textAlign: 'center',
          ...variantStyles.label
        }}
      >
        {label}
      </span>
    </button>
  );
};

function getStyles(active: boolean, isHovered: boolean, disabled: boolean) {
  const showAccent = !disabled && (active || isHovered);
  return {
    btn: {
      background: showAccent ? C.accentSurface : 'transparent',
      color: showAccent ? C.accent : C.textMuted,
      border: 'none',
      opacity: disabled ? 0.4 : 1
    } as React.CSSProperties,
    label: {
      fontWeight: active ? 600 : 400
    } as React.CSSProperties
  };
}
